/* Small, side-effect-free hierarchy helpers used by the collection filter engine. */
(() => {
  'use strict';
  const plain = s => String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const compact = s => plain(s).toLowerCase().replace(/[^a-z0-9]/g, '');
  const words = s => plain(s).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  function label(value) {
    let s = String(value || '').trim();
    s = s.replace(/\bADV\b/ig, 'Adventure');
    if (/^(?:YFZ350|YFZ350 Banshee|Banshee 350)$/i.test(s)) return 'Banshee 350';
    return s;
  }
  // A parent includes its real descendants. A child never includes siblings.
  function contains(parent, child) {
    const a = compact(label(parent)), b = compact(label(child));
    if (!a || !b) return false;
    if (a === b) return true;
    if (!/\d/.test(a)) {
      const aa = words(label(parent)), bb = words(label(child));
      return aa.length >= 4 && (` ${bb} `).includes(` ${aa} `);
    }
    if (/^[a-z]+\d{2,4}$/.test(a)) return b.startsWith(a) && /^[a-z]/.test(b.slice(a.length));
    const family = a.match(/^(\d{2,4})(adventure|duke)$/);
    if (family && new RegExp(`^${family[1]}(?:super|lc8)${family[2]}(?:[a-z]|$)`).test(b)) return true;
    const supermoto = a.match(/^(950|990)supermoto$/);
    if (supermoto && new RegExp(`^${supermoto[1]}sm[rt]?$`).test(b)) return true;
    const beta = a.match(/^(\d{3})rr$/);
    if (beta) return b.startsWith(a) && /^(?:2t|4t|race|xpro|s)/.test(b.slice(a.length));
    return words(label(child)).startsWith(words(label(parent)) + ' ');
  }
  window.NICECNCFacetPolicy = { compact, label, contains };
})();
